import React from "react";
import PropTypes from "prop-types";
import ClickOutside from "../ClickOutside";
import Button from "../../../../src/ui/Button";
import XMarkIcon from "../../../ui/icons/XMarkIcon";

export default function ChangeNotificationModal(props) {
    return (
        <ClickOutside
            onClickOutsideCallback={props.toggleOffChangeNotificationCallback}
        >
            <div id="change-notification-container" className="rounded-xl">
                <div id="change-notification-title">
                    <div className="text-2xl font-medium">
                        {props.titleText}
                    </div>
                </div>
                <div id="change-notification-subtitle">
                    <div>{props.descriptionText}</div>
                </div>
                <div id="change-list-container" className="rounded-md">
                    <div id="change-list">{props.notifications}</div>
                </div>
                <Button
                    id="change-notification-proceed"
                    className="mx-auto"
                    onClick={props.proceedBtnCallback}
                    variant="primary"
                    text={props.proceedText}
                    size="sm"
                />
                <XMarkIcon
                    id="change-notification-x-btn"
                    alt="Exit"
                    className="click-outside-ignore absolute top-2.5 right-2.5 cursor-pointer"
                    onClick={props.toggleOffChangeNotificationCallback}
                />
            </div>
        </ClickOutside>
    );
}

ChangeNotificationModal.propTypes = {
    titleText: PropTypes.string.isRequired,
    descriptionText: PropTypes.string.isRequired,
    proceedText: PropTypes.string.isRequired,
    notifications: PropTypes.array,
    toggleOffChangeNotificationCallback: PropTypes.func,
    proceedBtnCallback: PropTypes.func,
};

ChangeNotificationModal.defaultProps = {
    notifications: [],
    toggleOffChangeNotificationCallback: undefined,
    proceedBtnCallback: undefined,
};
